import { Error } from '../hooks/useApi';

/**
 *
 * Ensures that the error is of the following format:
 *
 * {
 *    error: {
 *      message: string
 *    }
 * }
 */
function formatResponseError(error: unknown): Error {
  let responseError: Error;

  if (
    typeof error === 'object' &&
    error !== null &&
    'error' in error &&
    typeof error.error === 'object' &&
    error.error !== null &&
    'message' in error.error &&
    typeof error.error.message === 'string'
  ) {
    responseError = {
      message: error.error.message,
    };
  } else {
    responseError = {
      message: 'Received unexpected response error',
    };
  }

  return responseError;
}

export default formatResponseError;
